import { render, staticRenderFns } from "./Udemo.vue?vue&type=template&id=ef7fb90e&scoped=true&"
import script from "./Udemo.vue?vue&type=script&lang=js&"
export * from "./Udemo.vue?vue&type=script&lang=js&"
import style0 from "./Udemo.vue?vue&type=style&index=0&id=ef7fb90e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7fb90e",
  null
  
)

export default component.exports